<template>
	<div>
		<CForm class="d-flex align-items-start" @submit.prevent="handleSubmit">
			<CInput
				v-model.trim="inputBranchId"
				:is-valid="isValid && null"
				:label="label"
				:placeholder="placeholder"
				:description="$t('global.separateBySemicolon')"
				class="flex-fill"
				add-input-classes="form-get-sku-input"
				data-test-id="input-sku"
			>
				<template #invalid-feedback>
					<div
						v-if="!isValid"
						class="invalid-feedback"
						data-test-id="error-item-invalid"
					>
						{{ invalidFeedback }}
					</div>
				</template>
			</CInput>
			<CButton
				type="submit"
				class="btn-add ml-2"
				color="secondary"
				data-test-id="button-add"
			>
				{{ actionButtonText }}
			</CButton>
		</CForm>
		<slot v-if="!selectedList.length" name="no-item">
		</slot>
		<div
			v-else
			class="list-item"
			:class="{ 'show-border': hasBorder }"
		>
			<h6 class="typo-body-2">
				Branch
			</h6>
			<p class="show-text">
				{{ showText }}
			</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FormGetExcludeStore',
	props: {
		label: {
			type: String,
			default: null,
		},
		selectedList: {
			type: Array,
			default: () => [],
		},
		hasBorder: {
			type: Boolean,
			default: false,
		},
		isValid: {
			type: Boolean,
			default: true,
		},
		invalidFeedback: {
			type: String,
			default: null,
		},
		placeholder: {
			type: String,
			default: 'Paste or type Branch ID number here',
		},
		actionButtonText: {
			type: String,
			default: 'Add SKU',
		},
	},
	data() {
		return {
			inputBranchId: '',
			isLoading: true,
		};
	},
	computed: {
		showText() {
			return this.selectedList.join('; ');
		},
	},
	methods: {
		resetState() {
			this.inputBranchId = '';
		},
		getListFromInputSKU(inputBranchId) {
			let list = inputBranchId.split(';');

			// trim all items and remove null
			list = list.map((item) => item.trim()).filter((item) => item);

			// remove duplicates
			return [...new Set(list)];
		},
		async handleSubmit() {
			if (!this.inputBranchId) {
				return;
			}

			const mergedInput = `${this.showText}; ${this.inputBranchId}`;
			const list = this.getListFromInputSKU(mergedInput);
			this.$emit('onGetProduct', list);
			this.resetState();
		},
	},
};
</script>

<style lang="scss" scoped>
	::v-deep .input-group-text {
		padding-right: 0;
	}

	::v-deep .form-get-sku-input {
		margin-right: rem(100);
	}

	.btn-add {
		min-width: rem(84);
	}

	.list-item {
		padding-bottom: rem(16);
		max-height: rem(320);
		overflow: auto;
	}

	.show-text {
		max-height: rem(272);
		font-size: rem($font-size-caption);
		font-weight: $font-weight-semi-bold;
		color: $color-black-45;
		margin: 0;
		overflow-x: hidden;
		overflow-wrap: break-word;
	}

	.show-border {
		border: solid 1px $color-gray-400;
		border-radius: rem(4);
	}
</style>
